import * as React from 'react'
import Layout from './components/Layout'

export default class Page404 extends React.Component {
  render() {
    return (
      <Layout title="404" desc="Oops! You're lost.">
        <p className="text-muted">The page you are looking for was not found.</p>
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Errors/404.tsx